import { createSearchParams } from 'react-router-dom';
import { DashboardAnalyticsDateRangeDays, rollingSubmittedDateRange } from './dashboardAnalytics';

// The app routes with HashRouter, so dashboard click-throughs are plain `#/...` anchors:
// they open the targeted content in a new tab while the current tab keeps its dashboard state,
// and right-click "open in new tab" works because they are real links.
export function useDashboardNavigation(dateRangeDays: DashboardAnalyticsDateRangeDays) {
  const getApplicationsHref = ({
    platform = 'all',
    appType = 'all',
    analysisStatus = 'all',
    categories = 'all',
    searchQuery = '',
    riskName = '',
    vendorName = '',
    cveId = '',
  }: {
    platform?: 'all' | 'android' | 'ios';
    appType?: string;
    analysisStatus?: string;
    categories?: string;
    searchQuery?: string;
    riskName?: string;
    vendorName?: string;
    cveId?: string;
  } = {}) => {
    const { startDate, endDate } = rollingSubmittedDateRange(dateRangeDays);
    const params: Record<string, string> = {
      platform,
      appType,
      startDate,
      endDate,
      analysisStatus,
      categories,
      searchQuery,
    };
    if (riskName) {
      params.riskName = riskName;
    }
    if (vendorName) {
      params.developerName = vendorName;
    }
    if (cveId) {
      params.cveId = cveId;
    }
    return `#/applications?${createSearchParams(params)}`;
  };

  const getAppReportHref = (analysisId: string, { focusSbomTab = false }: { focusSbomTab?: boolean } = {}) => {
    const params: Record<string, string> = {
      analysisId,
      backQParams: '',
    };
    if (focusSbomTab) {
      // The report's RootTabs reads this param to open on the SBOM tab.
      params.tab = 'sbom';
    }
    return `#/applications/app-detail-report?${createSearchParams(params)}`;
  };

  return { getApplicationsHref, getAppReportHref };
}
